const fmtNumber = new Intl.NumberFormat("pt-BR");
const fmtDate = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});
const fmtDateTime = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function n(v: number): string {
  return fmtNumber.format(v);
}

export function nPad3(v: number): string {
  return String(v).padStart(3, "0");
}

// String ISO vinda da API ("2026-10-25" ou "2026-10-25T14:30:00.000Z"): o mssql/tedious devolve a
// hora de PAREDE de Brasília nos campos UTC, então formata pelos dígitos (fatiando a string) — via
// new Date() + fuso, "2026-10-25" viraria 24/10 e a hora sairia 3h a menos.
const RE_ISO = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/;

export function dateBR(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  if (typeof iso === "string") {
    const m = RE_ISO.exec(iso);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return fmtDate.format(d);
}

export function dateTimeBR(iso: string | Date | null | undefined): string {
  if (!iso) return "";
  if (typeof iso === "string") {
    const m = RE_ISO.exec(iso);
    if (m) return `${m[3]}/${m[2]}/${m[1]} ${m[4] ?? "00"}:${m[5] ?? "00"}`   // HH:MM, sem segundos (Ricardo 25/10);
  }
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return fmtDateTime.format(d).replace(",", ""); // Intl pt-BR põe "dd/mm/aaaa, hh:mm"
}

// "1234h 05min" para durações longas, "1:05" para curtas
export function formatMinutes(min: number): string {
  if (!min || min < 0) return "—";
  const h = Math.floor(min / 60);
  const m = min % 60;
  const mStr = m < 10 ? "0" + m : String(m);
  if (h >= 100) return `${h}h ${mStr}min`;
  return `${h}:${mStr}`;
}

// Duração em segundos → "45s", "2min 10s", "1h 05min", "702h 15min".
export function formatDuration(seg: number | null | undefined): string {
  if (seg == null || seg < 0) return "—";
  if (seg < 60) return `${seg}s`;
  const totalMin = Math.floor(seg / 60);
  const s = seg % 60;
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) {
    const mStr = m < 10 ? "0" + m : String(m);
    return `${h}h ${mStr}min`;
  }
  const sStr = s < 10 ? "0" + s : String(s);
  return s > 0 ? `${m}min ${sStr}s` : `${m}min`;
}

export function formatDecimal(v: number, decimals = 2): string {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(v);
}
